import { Component, inject, input } from '@angular/core';
import { ClickOutside } from '@shared/directives/click-outside';
import { AuthenticationService } from '../../../services/authentication.service';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { UserAvatarComponent } from '@shared/components/user-avatar/user-avatar.component';
import { Router } from '@angular/router';
import { IFullFranchiseItem } from '@shared/constants/models.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../services/helper.service';

export interface IUserAttributes {
  reloaded?: boolean;
  attributes: {
    email: string;
    email_verified: boolean;
    family_name: string;
    given_name: string;
    sub: string;
    'custom:location': string;
    'custom:preferred_content': string
  };
  id: number;
}

@Component({
  selector: 'app-profile-dropdown',
  imports: [
    ClickOutside,
    UserAvatarComponent,
    TranslateModule,
  ],
  templateUrl: './profile-dropdown.component.html',
  styleUrl: './profile-dropdown.component.scss',
})
export class ProfileDropdownComponent {
  user = input.required<IUserAttributes>();
  currentFr = input.required<IFullFranchiseItem>();
  isDropdownOpen = false;
  profilePhoto: string = '';
  protected readonly ButtonTypes = BUTTON_TYPES;

  readonly HELPER = inject(HelperService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthenticationService);


  get userName(): string {
    return `${this.user().attributes.given_name} ${this.user().attributes.family_name}`;
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  clickOutside() {
    this.isDropdownOpen = false;
  }

  navigateToProfile(): void {
    this.router.navigate([`${this.HELPER.frLoc}/profile`]);
    this.isDropdownOpen = false;
  }

  logout() {
    this.authService.signOut().then(() => {
      this.isDropdownOpen = false;
      this.authService.user.next(null);
      sessionStorage.removeItem('userReloaded');
      if (this.HELPER.getUrlArray().includes('profile')) {
        this.router.navigate([`${this.HELPER.frLoc}/home`]);
      }
    });
  }

  navigateToMyTopics() {
    this.router.navigate([`${this.HELPER.frLoc}/my-topics`]);
    this.isDropdownOpen = false;
  }
}
